module.exports = __webpack_public_path__ + "static/media/RADAR Logo.59bfef89.png";